import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";

export interface DeleteDashboardV2Result {
  success: boolean;
  error?: string;
}

export const deleteDashboardV2UseCase = async (
  dashboardId: string,
): Promise<DeleteDashboardV2Result> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    await apiUseCases.deleteDashboardV2(namespace, dashboardId);

    return { success: true };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to delete dashboard").message,
    };
  }
};
